import { Model } from '@/models/Model';
export class YearTemplate extends Model {
    constructor() {
        super(...arguments);
        this.$endpoint = '/year-templates';
        this.$name = 'YearTemplate';
        this.$fillable = [
            'name',
            'year_name',
            'starts_at',
            'ends_at',
            'periods',
        ];
    }
    apply(schoolIds) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/apply`;
        return this.request('post', url, { school_ids: schoolIds });
    }
}
